// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type OfferingDetailsStep_DevelopmentsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OfferingDetailsStep_DevelopmentsQuery = { __typename?: 'Query', developments: Array<{ __typename?: 'Development', id: string, name: string }> };

export type OfferingDetailsStep_CommunitiesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OfferingDetailsStep_CommunitiesQuery = { __typename?: 'Query', projects: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  > };


export const OfferingDetailsStep_DevelopmentsDocument = gql`
    query OfferingDetailsStep_Developments {
  developments {
    ...Named
  }
}
    ${NamedFragmentDoc}`;

/**
 * __useOfferingDetailsStep_DevelopmentsQuery__
 *
 * To run a query within a React component, call `useOfferingDetailsStep_DevelopmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferingDetailsStep_DevelopmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferingDetailsStep_DevelopmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOfferingDetailsStep_DevelopmentsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OfferingDetailsStep_DevelopmentsQuery, OfferingDetailsStep_DevelopmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OfferingDetailsStep_DevelopmentsQuery, OfferingDetailsStep_DevelopmentsQueryVariables>(OfferingDetailsStep_DevelopmentsDocument, options);
      }
export function useOfferingDetailsStep_DevelopmentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OfferingDetailsStep_DevelopmentsQuery, OfferingDetailsStep_DevelopmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OfferingDetailsStep_DevelopmentsQuery, OfferingDetailsStep_DevelopmentsQueryVariables>(OfferingDetailsStep_DevelopmentsDocument, options);
        }
// @ts-ignore
export function useOfferingDetailsStep_DevelopmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OfferingDetailsStep_DevelopmentsQuery, OfferingDetailsStep_DevelopmentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OfferingDetailsStep_DevelopmentsQuery, OfferingDetailsStep_DevelopmentsQueryVariables>;
export function useOfferingDetailsStep_DevelopmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OfferingDetailsStep_DevelopmentsQuery, OfferingDetailsStep_DevelopmentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OfferingDetailsStep_DevelopmentsQuery | undefined, OfferingDetailsStep_DevelopmentsQueryVariables>;
export function useOfferingDetailsStep_DevelopmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OfferingDetailsStep_DevelopmentsQuery, OfferingDetailsStep_DevelopmentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OfferingDetailsStep_DevelopmentsQuery, OfferingDetailsStep_DevelopmentsQueryVariables>(OfferingDetailsStep_DevelopmentsDocument, options);
        }
export type OfferingDetailsStep_DevelopmentsQueryHookResult = ReturnType<typeof useOfferingDetailsStep_DevelopmentsQuery>;
export type OfferingDetailsStep_DevelopmentsLazyQueryHookResult = ReturnType<typeof useOfferingDetailsStep_DevelopmentsLazyQuery>;
export type OfferingDetailsStep_DevelopmentsSuspenseQueryHookResult = ReturnType<typeof useOfferingDetailsStep_DevelopmentsSuspenseQuery>;
export type OfferingDetailsStep_DevelopmentsQueryResult = Apollo.QueryResult<OfferingDetailsStep_DevelopmentsQuery, OfferingDetailsStep_DevelopmentsQueryVariables>;
export const OfferingDetailsStep_CommunitiesDocument = gql`
    query OfferingDetailsStep_Communities {
  projects(filter: {type: [Community]}) {
    ...Named
  }
}
    ${NamedFragmentDoc}`;

/**
 * __useOfferingDetailsStep_CommunitiesQuery__
 *
 * To run a query within a React component, call `useOfferingDetailsStep_CommunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferingDetailsStep_CommunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferingDetailsStep_CommunitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useOfferingDetailsStep_CommunitiesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OfferingDetailsStep_CommunitiesQuery, OfferingDetailsStep_CommunitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OfferingDetailsStep_CommunitiesQuery, OfferingDetailsStep_CommunitiesQueryVariables>(OfferingDetailsStep_CommunitiesDocument, options);
      }
export function useOfferingDetailsStep_CommunitiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OfferingDetailsStep_CommunitiesQuery, OfferingDetailsStep_CommunitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OfferingDetailsStep_CommunitiesQuery, OfferingDetailsStep_CommunitiesQueryVariables>(OfferingDetailsStep_CommunitiesDocument, options);
        }
// @ts-ignore
export function useOfferingDetailsStep_CommunitiesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OfferingDetailsStep_CommunitiesQuery, OfferingDetailsStep_CommunitiesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OfferingDetailsStep_CommunitiesQuery, OfferingDetailsStep_CommunitiesQueryVariables>;
export function useOfferingDetailsStep_CommunitiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OfferingDetailsStep_CommunitiesQuery, OfferingDetailsStep_CommunitiesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OfferingDetailsStep_CommunitiesQuery | undefined, OfferingDetailsStep_CommunitiesQueryVariables>;
export function useOfferingDetailsStep_CommunitiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OfferingDetailsStep_CommunitiesQuery, OfferingDetailsStep_CommunitiesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OfferingDetailsStep_CommunitiesQuery, OfferingDetailsStep_CommunitiesQueryVariables>(OfferingDetailsStep_CommunitiesDocument, options);
        }
export type OfferingDetailsStep_CommunitiesQueryHookResult = ReturnType<typeof useOfferingDetailsStep_CommunitiesQuery>;
export type OfferingDetailsStep_CommunitiesLazyQueryHookResult = ReturnType<typeof useOfferingDetailsStep_CommunitiesLazyQuery>;
export type OfferingDetailsStep_CommunitiesSuspenseQueryHookResult = ReturnType<typeof useOfferingDetailsStep_CommunitiesSuspenseQuery>;
export type OfferingDetailsStep_CommunitiesQueryResult = Apollo.QueryResult<OfferingDetailsStep_CommunitiesQuery, OfferingDetailsStep_CommunitiesQueryVariables>;